import { getOrganizationDepartments } from 'api';
import { useQuery } from 'react-query';

const useOrgDepartments = (orgId) => {

    const { data, isLoading, isError } = useQuery({
        queryKey: ["OrganizationDepartments", orgId],
        queryFn: () => getOrganizationDepartments(orgId),
        refetchOnWindowFocus: false,
        staleTime: 30 * 60 * 1000,
        cacheTime: 60 * 60 * 1000,
        retry: 3,

    });

    return { id: data?.orgId, data: data?.departments || [], isLoading, isError };
};

export default useOrgDepartments;